import './BilllingListCardSkeletonLoader.scss';

const BilllingListCardSkeletonLoader = () => {
  return (
    <div className="billlingListCardSkeletonLoader">
      <div className="tableField id">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField client">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField billingEntityBord">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField warehouse">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField invoiceNumber">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField month">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField amount">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="tableField billlingStatus">
        <div className="skeletonLoader animationLoader" />
      </div>
      <div className="actions">
        <div className="skeletonLoader animationLoader" />
      </div>
    </div>
  );
};

export default BilllingListCardSkeletonLoader;
